import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { BaseHttpService } from "./base-http.service";

import { TResponse } from "@app/core/types/response.type";

/**
 * Shape of the `/api/app/config` response. Mirrors
 * `PolicyAdmin.Application.Features.AppConfig.Dtos.AppConfigDto`.
 */
export interface IAppConfig {
  enabledModules: EAppModule[];
}

/**
 * Known module names exposed by the backend: plugin modules (the `PolicyAdmin.Modules.`
 * prefix stripped) and built-in modules that the same `Modules:Enabled` setting switches.
 */
export enum EAppModule {
  GeneralLedger     = "GeneralLedger",
  ApprovalWorkflow  = "ApprovalWorkflow",
  Quote             = "Quote",
  CaptiveManagement = "CaptiveManagement",
  Reporting         = "Reporting",
  Claims            = "Claims",
  /** Loss Run Intelligence: core code, switched per environment like a plugin. */
  LossRun           = "LossRun",
}

/**
 * Raw HTTP client for `/api/app/config`. Pure transport layer — no `map`,
 * `share`, `catchError`. Caching, transformation and the convenience helpers
 * (`isModuleEnabled$`, the enabled-modules signal) live in
 * {@link AppConfigStoreService}.
 */
@Injectable({ providedIn: "root" })
export class AppConfigService {
  private readonly http$ = inject(BaseHttpService);

  getAppConfig(): Observable<TResponse<IAppConfig>> {
    return this.http$.get<TResponse<IAppConfig>>("app/config");
  }
}
